var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileDownload = function SvgFileDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M.75 0A.752.752 0 0 0 0 .75v10.5c0 .412.338.75.75.75h7.5c.412 0 .75-.338.75-.75V2.79L6.184 0H.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M6.843 2.79H9L6.187 0v2.125c0 .39.26.666.656.666Z"
  })));
};
export default SvgFileDownload;